/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {Component} from 'react';
// material
import {
    Content,
    SubDivision,
    Title,
    Link,
    DateRangePickerDropDown,
    ListTable,
    getDateNYC,
    isAfterFourPM,
    zeroPadding,
    StandardPagination
} from '@insticator/insticator-ui'; // iui-material
import BackToEmbedsCTA from 'material/ctas/backtoembeds/backtoembeds';
// utils

// // styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/emails/embedemails_styles';



/* ========== ~~~~~~~~~~ EMBED ANALYTICS ~~~~~~~~~~ ========== */
class EmbedEmails extends Component{
    constructor(props){
        super(props);
        this.rowsPerPage = 10;
        this.state = {
            startDate: generateDefaultStartDate(),
            endDate: generateDefaultEndDate()
        }
    }

    componentDidMount() {
        //(embedUUID, page, startDate, endDate)
        if(!this.props.selectedEmbed){
            return this.props.moveToPage('dashboard/embeds')
        }
        this.fetchEmails(this.props.currentPage);
    }

    componentWillUnmount() {
        this.props.clearSelectedEmailState();
    }

    fetchEmails = (page) => this.props.getEmailData(this.props.selectedEmbed, page, this.state.startDate, this.state.endDate);

    handlePagination = (btn) => {
        let page = this.props.currentPage;
        switch (btn) {
            case 'previous':
                return this.fetchEmails(page - 1);
            default:
            case 'next':
                return this.fetchEmails(page + 1);
        }
    };

    handleDownload = () => this.props.downloadEmailData(this.props.selectedEmbed, 1, this.state.startDate, this.state.endDate);

    renderPagination = () => {
        if(this.props.loading || this.props.totalRows <= this.rowsPerPage){
            return null
        }
       return <StandardPagination
            currentIndex={this.rowsPerPage * this.props.currentPage}
            currentPage={this.props.currentPage}
            itemsPerPage={this.rowsPerPage}
            totalItems={this.props.totalRows}
            firstLastButtons={false}
            handlePrevious={this.handlePagination}
            handleNext={this.handlePagination} />
    }
    render(){

        return(
            <SubDivision name={`embedemails`} klass={this.props.classes.embedemails}>
                <div id={`main`}>
                    <Content>
                        <BackToEmbedsCTA />
                        <Title variant={'withctas'}>
                            <h3>
                                Collected User Emails
                            </h3>
                            <DateRangePickerDropDown
                                handleApply={()=>this.fetchEmails(this.props.currentPage)}
                                updateRange={(range) => this.setState({startDate: range.from, endDate: range.to})}
                                range={{from: this.state.startDate, to: this.state.endDate}}
                                 />
                        </Title>
                        <div className={'export'}>
                            <Link
                                type={'action'}
                                text={'Export Data'}
                                action={this.handleDownload}
                                icon={'arrow-circle-down'}
                                iconRight={true}
                                operation={'download'}
                                processing={this.props.downloading}
                            />
                        </div>
                        <ListTable
                            name={'table'}
                            type={'fixed-column'}
                            variant={'standard'}
                            size={'full'}
                            loading={this.props.loading}
                            paginationLocation={null}
                            data={this.props.embedEmails}
                            columnHeads={{date: 'Date', email: 'User email', city: 'City', country: 'Country'}}
                            rowsPerPage={this.rowsPerPage}
                            fixedColWidth={212} />
                        {this.renderPagination()}
                    </Content>
                </div>
            </SubDivision>);
    }
}




/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedEmails);

const generateDefaultStartDate = () => {
    let week = new Date(new Date() - (1000 * 60 * 60 * 24 * 6));
    return `${week.getFullYear()}-${zeroPadding((week.getMonth() + 1), 2)}-${zeroPadding(week.getDate(), 2)}`;
};

const generateDefaultEndDate = () => {
    let today = new Date();
    return `${today.getFullYear()}-${zeroPadding((today.getMonth() + 1), 2)}-${zeroPadding(today.getDate(), 2)}`;
};
